const selectSpearPhishingAgentInfo = (state) => state.spearPhishingAgent.scheduleInfo
const selectAccessError = (state) => state.spearPhishingAgent.accessError
const selectPsimaCompanyIds = (state) => state.spearPhishingAgent.psimaCompanyIds
const selectPsimaCompaniesLoaded = (state) => state.spearPhishingAgent.psimaCompaniesLoaded
const selectPsimaCompaniesError = (state) => state.spearPhishingAgent.psimaCompaniesError
const selectCampaignsData = (state) => state.spearPhishingAgent.campaignsData
const selectExcludedParticipants = (state) =>
  state.spearPhishingAgent.campaignsData.excludedParticipants
const selectLaunchLoader = (state) => state.spearPhishingAgent.launchLoader
const selectRiskLevelSelectedFilters = (state) =>
  state.spearPhishingAgent.campaignsData.riskLevelSelectedFilters
const selectPlaceholderFilter = (state) => state.spearPhishingAgent.campaignsData.placeholderFilter
const selectCardsOrdering = (state) => state.spearPhishingAgent.campaignsData.ordering
const selectCampaignsTotalCount = (state) => state.spearPhishingAgent.campaignsData.totalCount
const selectSimulationData = (state) => state.spearPhishingAgent.simulationData
const selectSingleCampaignId = (state) => state.spearPhishingAgent.singleCampaignId
const selectLevelCountsData = (state) => state.spearPhishingAgent.levelCountsData
const selectMetricBannerData = (state) => state.spearPhishingAgent.metricBannerData
const selectStatusCountsData = (state) => state.spearPhishingAgent.statusCountsData

export {
  selectSpearPhishingAgentInfo,
  selectAccessError,
  selectPsimaCompanyIds,
  selectPsimaCompaniesLoaded,
  selectPsimaCompaniesError,
  selectCampaignsData,
  selectExcludedParticipants,
  selectLaunchLoader,
  selectRiskLevelSelectedFilters,
  selectPlaceholderFilter,
  selectCardsOrdering,
  selectCampaignsTotalCount,
  selectSimulationData,
  selectSingleCampaignId,
  selectLevelCountsData,
  selectMetricBannerData,
  selectStatusCountsData,
}
